import { format, parseISO } from 'date-fns';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import StatusPill from '../../../../v2/js/components/StatusPill';
import { WorkflowScopes } from '../../../../v2/js/constants/workflows';
import { ConnectedFacility } from '../../../api';
import { Card } from '../Card';

interface FacilityCardProps {
  data: ConnectedFacility;
  onConnectionSelect?: (connectionId: string | null) => void;
}

export const FacilityCard = ({ data, onConnectionSelect }: FacilityCardProps) => {
  const { updated_at } = data;
  const { id: facilityId, name, city, state } = data.facility;

  return (
    <>
      <Card.SubCard className="p-3 mt-3">
        <Row className="align-items-center justify-content-between">
          <Col xs="9">
            <Link to={`/app/organization/facilities/${facilityId}`} className="mb-2 pb-1">
              {name}
            </Link>
          </Col>
          <Col xs="3">
            <Button
              variant="outline-primary"
              className="btn btn-drop-shadow-sm px-2"
              size="sm"
              onClick={() => onConnectionSelect?.(data.id)}
            >
              Open
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs="12" className="fs-14 mb-2">
            {city}, {state}
          </Col>

          <Col xs="12" className="fs-14 mb-2">
            <StatusPill
              scope={WorkflowScopes.ConnectedFacility}
              status={data?.current_status}
              small
            />
          </Col>
        </Row>
        <div className="d-flex justify-content-start mt-1">
          <small>{format(parseISO(updated_at), 'LLL d, yyyy')}</small>
        </div>
      </Card.SubCard>
    </>
  );
};
